import React from "react";
import {
  Box,
  Grid,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextareaAutosize,
  styled,
} from "@mui/material";
import MWCaption from "../../components/MWCaption";

import PostAddIcon from "@mui/icons-material/PostAdd";
import {Controller, useFormContext} from "react-hook-form";
import MWInputFile from "../../components/MWInputFile";
import {suggestionType} from "../../models/serverModels/report/EQSuggestion";

const ManageTableContainer = styled(Grid)(({theme}) => ({
  marginTop: "32px",
  flexFlow: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: theme.palette.gray.main,
}));

export const ManageTable = styled(TableContainer)(({theme}) => ({
  width: "80%",
  marginTop: "48px",
  marginBottom: "32px",
  paddingLeft: "16px",
  paddingTop: "32px",
  paddingRight: "16px",
  paddingBottom: "32px",
  backgroundColor: theme.palette.gray.dark,
  boxShadow: `rgb(0 0 0 / 10%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(0 0 0 / 6%) 0rem 0.125rem 0.25rem -0.0625rem`,

  "& .subTitle": {
    fontSize: "18px",
    fontWeight: 600,
  },
  "& table th, td": {
    border: `1px solid ${theme.palette.warning.main}`,

    [theme.breakpoints.down("sm")]: {
      padding: "8px",
    },
  },
  "& tbody th": {
    padding: "8px",
    width: "10%",
    fontWeight: 700,
    backgroundColor: theme.palette.custom.light,
  },
  "& tbody td": {
    width: "40%",
  },
  "& textarea": {
    lineHeight: 1.5,
  },

  [theme.breakpoints.down("lg")]: {
    width: "80%",
    padding: "8px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    padding: 0,
  },
}));

function SuggestionForm() {
  const {control} = useFormContext();
  return (
    <React.Fragment>
      <ManageTableContainer container rowSpacing={4}>
        <MWCaption title="질의 작성" color="#880E4F" icon={<PostAddIcon />} />
        <ManageTable>
          <Box sx={{margin: "auto", width: "100%"}}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell component="th">제목</TableCell>
                  <TableCell colSpan={3}>
                    <Controller
                      name="title"
                      control={control}
                      render={({field: {onChange, value}}) => (
                        <TextareaAutosize
                          defaultValue={value}
                          aria-label="minimum height"
                          minRows={1}
                          onChange={onChange}
                          style={{width: "100%", padding: "8px", resize: "none"}}
                        />
                      )}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">유형</TableCell>
                  <TableCell colSpan={3}>
                    <Controller
                      name="type"
                      control={control}
                      render={({field}) => (
                        <Grid container alignItems="center" justifyContent="flex-start">
                          <Grid item xs={12}>
                            <Select
                              {...field}
                              id="type"
                              size="small"
                              defaultValue={field.value}
                              style={{width: "100%"}}
                            >
                              <MenuItem disabled value={field.value} style={{display: "none"}}>
                                선택하세요
                              </MenuItem>
                              {suggestionType! !== undefined &&
                                suggestionType!.map((item, index) => (
                                  <MenuItem key={index} value={index}>
                                    {item}
                                  </MenuItem>
                                ))}
                            </Select>
                          </Grid>
                        </Grid>
                      )}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">URL</TableCell>
                  <TableCell colSpan={3}>
                    <Controller
                      name="url"
                      control={control}
                      render={({field: {onChange, value}}) => (
                        <TextareaAutosize
                          defaultValue={value}
                          aria-label="minimum height"
                          minRows={1}
                          onChange={onChange}
                          style={{width: "100%", padding: "8px", resize: "none"}}
                        />
                      )}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">내용</TableCell>
                  <TableCell colSpan={3}>
                    <Controller
                      name="report"
                      control={control}
                      render={({field: {onChange, value}}) => (
                        <TextareaAutosize
                          defaultValue={value}
                          aria-label="minimum height"
                          minRows={6}
                          onChange={onChange}
                          style={{width: "100%", padding: "8px", whiteSpace: "pre-line"}}
                        />
                      )}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" width="25%">
                    첨부이미지
                  </TableCell>
                  <TableCell>
                    <MWInputFile file="base64Image" fileName="imageFileName" buttonLabel="찾기" />
                  </TableCell>
                  <TableCell component="th" width="25%">
                    파일선택
                  </TableCell>
                  <TableCell>
                    <MWInputFile file="base64Other" fileName="otherFileName" buttonLabel="찾기" />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        </ManageTable>
      </ManageTableContainer>
    </React.Fragment>
  );
}

export default SuggestionForm;
